import {ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AiService} from "../../services/ai/ai.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {LocalStoreService, SceneAddService, StoreSelectorsService, UserService} from "../../services";
import {
    trigger,
    style,
    animate,
    transition,
    state
} from '@angular/animations';
import {CdkDragEnd} from "@angular/cdk/drag-drop";
import {timeout} from "../../decorators/timeout";
import {Router} from "@angular/router";
import {delay, tap} from "rxjs/operators";




@Component({
  selector: 'app-ai-prompt',
  templateUrl: './ai-prompt.component.html',
  styleUrl: './ai-prompt.component.scss',
    animations: [
        trigger('dialogAnim', [
            transition(':enter', [
                style({ opacity: 0, transform: '{{startTransform}}' }),
                animate(
                    '400ms ease-out',
                    style({ opacity: 1, transform: 'translate(0, 0) scale(1)' })
                )
            ], {
                params: { startTransform: 'translate(100%, -100%) scale(0)' } // default value
            }),

            transition(':leave', [
                animate(
                    '400ms ease-in',
                    style({ opacity: 0.6, transform: '{{startTransform}}' })
                )
            ], {
                params: { startTransform: 'translate(100%, -100%) scale(0)' } // default value
            })
        ])
    ]
})
export class AiPromptComponent implements OnInit {
    dialogStartTransform;

    private resizing = false;
    private resizeDirection: 'top' | 'bottom' | 'left' | 'right' = 'right';

    assistantSettings;
    prompt = '';
    dialogText = '';
    infoMessage = '';
    waitMessage = '';
    busy = false;

    showDialog = false;
    isDragging = false;
    offset = {x: 0, y: 0};

    imageMessage;
    imageUrl;
    imageTitle;
    imageSize;

    isWaiting = false;
    spinnerFrames = ['|', '/', '-', '\\'];
    currentSpinnerIndex = 0;
    spinnerInterval: any;

    transcript = '';
    recognition: any;
    isListening = false;

    dialogState = {
        top: 200,
        left: 400,
        width: 800,
        height: 600
    };

    @ViewChild('aiDialog') aiDialog!: ElementRef<HTMLElement>;
    @ViewChild('textArea') textArea!: ElementRef<HTMLTextAreaElement>;

    @ViewChild('imageTemplate') imageTemplate!: TemplateRef<any>;
    dialogRef2!: MatDialogRef<any>;

    constructor(private dialog: MatDialog,
                private aiService: AiService,
                private userService: UserService,
                private localStoreService: LocalStoreService,
                private storeSelector: StoreSelectorsService,
                private sceneAddService: SceneAddService,
                private router: Router,
                private cd: ChangeDetectorRef) {

    }

    ngOnInit() {
        this.storeSelector.getLocalStoreUpdates()
            .subscribe((updates) => {
                this.assistantSettings = this.localStoreService.getStorageValConfig('assistant');
            });

        this.aiService.showDialog$.pipe(
            tap( show => {
                this.updateDialogState();
                const x = this.aiService.x - (this.dialogState.left + this.dialogState.width / 2);
                const y = this.aiService.y - (this.dialogState.top + this.dialogState.height / 2);
                this.dialogStartTransform = `translate(${x}px, ${y}px) scale(0)`;
            }),
            delay(10)
        ).subscribe(show => {


            this.showDialog = show;
        });

        this.aiService.busy$.subscribe(busy => {
            this.busy = busy;
        });

        this.aiService.log$.subscribe(message => {
            const msg: any = message;
            this.stopSpinner();

            this.infoMessage += msg.text;
            this.dialogText = this.infoMessage;
            this.scrollToBottom();

            if (msg.wait) {
                this.startSpinner();
            } else {
                this.infoMessage += '\n';
            }


        });

        this.aiService.createImage$.subscribe(imageMessage => {
            debugger;
            this.imageMessage = imageMessage;
            this.imageUrl = this.imageMessage.imageUrl;
            this.imageTitle = this.imageMessage.functionArgs.title;
            this.imageSize = this.imageMessage.functionArgs.size;
            this.dialogRef2 = this.dialog.open(this.imageTemplate, {
                width: '600px',
                height: '800px',
                disableClose: true
            });

        });


        const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        if (SpeechRecognition) {
            this.recognition = new SpeechRecognition();
            this.recognition.continuous = true;
            this.recognition.lang = 'en-US';

            this.recognition.onresult = (event: any) => {
                debugger;
                const last = event.results.length - 1;
                this.transcript += event.results[last][0].transcript + ' ';

                this.prompt = this.transcript;
            };

            this.recognition.onend = () => {
                debugger;
                this.isListening = false;
            };

            this.recognition.onerror = (event: any) => {
                debugger;
                console.error('Speech recognition error', event.error);
                this.isListening = false;
            };
        } else {
            alert('Speech recognition is not supported in this browser.');
        }
    }


    startResize(event: MouseEvent, direction: 'top' | 'bottom' | 'left' | 'right') {
        debugger
        event.preventDefault();
        this.resizing = true;
        this.resizeDirection = direction;

        const startX = event.clientX;
        const startY = event.clientY;
        const startWidth = this.dialogState.width;
        const startHeight = this.dialogState.height;
        const startTop = this.dialogState.top;
        const startLeft = this.dialogState.left;

        const onMouseMove = (moveEvent: MouseEvent) => {
            if (!this.resizing) return;

            const dx = moveEvent.clientX - startX;
            const dy = moveEvent.clientY - startY;

            switch (this.resizeDirection) {
                case 'right':
                    this.dialogState.width = startWidth + dx;
                    break;
                case 'left':
                    this.dialogState.width = startWidth - dx;
                    this.dialogState.left = startLeft + dx;
                    break;
                case 'bottom':
                    this.dialogState.height = startHeight + dy;
                    break;
                case 'top':
                    this.dialogState.height = startHeight - dy;
                    this.dialogState.top = startTop + dy;
                    break;
            }
        };

        const onMouseUp = () => {
            this.resizing = false;
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    }


    @timeout(10)
    scrollToBottom() {
        const el = this.textArea.nativeElement;
        el.scrollTop = el.scrollHeight;
    }

    toggleListening() {
        if (!this.recognition) return;

        if (this.isListening) {
            this.recognition.stop();
            this.isListening = false;
        } else {
            this.transcript = '';
            this.recognition.start();
            this.isListening = true;
        }
    }

    startSpinner() {
        this.isWaiting = true;

        this.spinnerInterval = setInterval(() => {
            const spinnerChar = this.spinnerFrames[this.currentSpinnerIndex];
            this.waitMessage = spinnerChar;
            this.dialogText = this.infoMessage + ' ' + this.waitMessage;
            this.scrollToBottom();
            this.currentSpinnerIndex = (this.currentSpinnerIndex + 1) % this.spinnerFrames.length;
        }, 200);
    }

    stopSpinner() {
        if (this.isWaiting) {
            clearInterval(this.spinnerInterval);
            this.spinnerInterval = null;
            this.isWaiting = false;
            this.infoMessage += '\n';
            this.dialogText = this.infoMessage;
            this.scrollToBottom();
        }
    }

    onSend(): void {
        this.infoMessage = '';
        this.dialogText = '';
        this.scrollToBottom();


        this.aiService.send(this.assistantSettings.name, this.prompt).subscribe(() => {
            this.prompt = "";
        });
    }

    onDragEnded(event: CdkDragEnd) {
        const element = event.source.element.nativeElement as HTMLElement;
        const transform = getComputedStyle(element).transform;

        if (transform && transform !== 'none') {
            const matrix = new DOMMatrixReadOnly(transform);

            // m41 = translateX, m42 = translateY
            this.dialogState.left += matrix.m41;
            this.dialogState.top += matrix.m42;

            // Reset transform so styles don't stack
            element.style.transform = 'none';

            // Apply updated position directly to the element to prevent visual jump
            element.style.left = this.dialogState.left + 'px';
            element.style.top = this.dialogState.top + 'px';

            event.source._dragRef.reset();
        }
    }

    hideDialog() {
        this.updateDialogState();
        this.aiService.showDialog(false);
    }

    settings() {
        this.router.navigate(["/user/ai"]);
        this.aiService.showDialog(false);
    }

    cleanView() {
        this.infoMessage = "";
        this.dialogText = "";
    }

    updateDialogState() {
        if (this.aiDialog != null) {
            const rect = this.aiDialog.nativeElement.getBoundingClientRect();
            this.dialogState = {
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height
            };
            console.log('updateDialogState');
        }
    }

    onDownloadImage() {
        this.aiService.downloadImage(this.imageMessage).subscribe(() => {
            this.dialogRef2.close();
        });
    }


}
